import type { KeystrokeLog, LogOp } from './types'

function assertRange(doc: string, op: LogOp): void {
  const valid =
    Number.isInteger(op.from) &&
    Number.isInteger(op.to) &&
    op.from >= 0 &&
    op.from <= op.to &&
    op.to <= doc.length
  if (!valid) {
    throw new RangeError(
      `op range ${op.from}..${op.to} is invalid for a document of length ${doc.length}`,
    )
  }
}

/** Returns a new document with the op's range replaced by its text. */
export function applyOp(doc: string, op: LogOp): string {
  assertRange(doc, op)
  return doc.slice(0, op.from) + op.text + doc.slice(op.to)
}

export function applyOps(doc: string, ops: readonly LogOp[]): string {
  return ops.reduce(applyOp, doc)
}

/** The document after the first `opCount` ops of the log. */
export function docAt(log: KeystrokeLog, opCount: number): string {
  return applyOps('', log.ops.slice(0, Math.max(0, opCount)))
}

export function finalDoc(log: KeystrokeLog): string {
  return applyOps('', log.ops)
}
